export const TimeHelper = {
    /**
     * @param date format Y-m-d H:i:s
     */
    isFuture(date: string): boolean {
        const isoDateString = date.replace(' ', 'T');
        return new Date(isoDateString) > new Date();
    },
};
